import React from "react";
import { useAmendmentReason } from "../../hooks/useAmendmentReason";
import Amendment from "../../../commonComponents/Amendment";
import { useSelector } from "react-redux";

const AmendmentReasons = () => {
  const methodList=useAmendmentReason({containerKey:"header"})
  const amendReasonTypeList = useSelector((state) => state.DropDownValues.correctionAmendmentReasons) || []; 
  
  return (
   <Amendment {...methodList} amendReasonTypeList={amendReasonTypeList} />
   );
}
export default React.memo(AmendmentReasons)
